import React, { FC } from 'react';
import { LegalEntityProvider } from 'common/context';
import {
  ConnectedSelfRegistrationLegalEntitiesInner,
  IComponentProps,
} from 'entities/Auth/components/SelfRegistration/SelfRegistrationLegalEntitiesInner';

export const SelfRegistrationLegalEntities: FC<IComponentProps> = (props) => {
  return (
    <LegalEntityProvider>
      <ConnectedSelfRegistrationLegalEntitiesInner {...props} />
    </LegalEntityProvider>
  );
};
